<app-modal-header-common title="Confirm Airo Query" [dialogRef]="dialogRef">
</app-modal-header-common>

<div class="control-form" style="overflow-y: scroll">
  <mat-form-field class="w-100" appearance="outline">
    <mat-label>Query <span class="required-asterisk">*</span></mat-label>
    <textarea matInput [formControl]="queryControl" rows="10"></textarea>
    <mat-hint>Please review the generated query and modify it if needed before proceeding to Airo.</mat-hint>
  </mat-form-field>
</div>

<div style="display: flex; justify-content: end; margin: 12px 24px 20px">
  <button mat-button color="primary" class="mx-1" (click)="closeModal()">
    Cancel
  </button>
  <button
    mat-flat-button
    color="primary"
    [disabled]="queryControl.invalid"
    (click)="proceed()"
  >
    Proceed to Airo
  </button>
</div>
